import axiosHttp from "services/axiosHttp";
import moment from "moment";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchRewardOrderInvoicesList = createAsyncThunk(
	"fetchRewardOrderInvoicesList",
	async ({ filters, page, limit }, { rejectWithValue }) => {
		let start_date = "";
		let end_date = "";

		if (filters?.range?.length === 2) {
			start_date = moment(filters.range[0].$d).format("YYYY-MM-DD");
			end_date = moment(filters.range[1].$d).format("YYYY-MM-DD");
		}

		const params = new URLSearchParams({
			page: page,
			limit: limit,
			keyword: filters?.keyword ?? "",
			startdate: start_date,
			enddate: end_date,
		});

		try {
			const response = await axiosHttp.get(`invoices?${params}`);
			return response.data.data;
		} catch (error) {
			return rejectWithValue(error.response?.data?.message || "Something went wrong");
		}
	}
);

const RewardOrderInvoicesListSlice = createSlice({
	name: "RewardOrderInvoicesListSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		total: 0,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchRewardOrderInvoicesList.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchRewardOrderInvoicesList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = action.payload.currentPage;
			state.total = action.payload.total;
		});

		builder.addCase(fetchRewardOrderInvoicesList.rejected, (state, action) => {
			state.isLoading = false;

			if (action.error.message) {
				state.error = action.error.message;
			} else {
				state.error = "Unknown error occurred";
			}
		});
	},
});

export default RewardOrderInvoicesListSlice.reducer;
